//liuxu
//新闻热搜
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['jquery'], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS
    module.exports = factory(require('jquery'));
  } else {
    // 浏览器全局变量(root 即 window)
    root.computationTime = factory(root.jQuery);
  }
}(this, function ($) {
  var hotSearch = {
    buildHotSearch: function (data) {
      var T = this,
        hotHtml = '';
      if (data && data.length) {
        hotHtml += '<div class="chinaso_xwrs_change"><i>换一换</i></div>';
        hotHtml += '<ul class="first-ul">';
        for (var i = 0; i < data.length && i < 30; i++) {
          var topnumclass = '';
          if (i < 3) {
            topnumclass = ' topnum';
          }
          var index = i + 1;
          hotHtml += '<li>'
                          + '<i class="i_' + index + '">' + index + '</i>'
                          + '<a href="javascript:void(0)" data-query="' + encodeURIComponent(data[i].event_query) + '">' + data[i].event_name + '</a>'
                          + '<span class="num' + topnumclass + '">' + data[i].hot_value + '</span>';
          if (data[i].flag == 1) {
            hotHtml += '<em class="new_icon">新</em>';
          }
          if (data[i].flag == 2) {
            hotHtml += '<em class="hot_icon">热</em>';
          }
          if (data[i].flag == -1) {
            hotHtml += '<em class="down_icon">降</em>';
          }
          if (data[i].flag == 3) {
            hotHtml += '<em class="fei_icon">沸</em>';
          }
          if (data[i].flag == 4) {
            hotHtml += '<em class="jian_icon">荐</em>';
          }
          // if (data[i].flag == 5) {
          //   hotHtml += '<em class="quan_icon">全貌</em>';
          // }
          hotHtml += '</li>';
          if (index == 5 || index == 10 || index == 15 || index == 20 || index == 25) {
            hotHtml += '</ul><ul>';
          }
        }
        hotHtml += '</ul>';
      }
      return hotHtml;
    },
    change: function () {
      if (this.index + 2 < this.len) {
        this.index += 2;
      } else {
        this.index = 0;
      }
      this.showHotSearch();
    },
    showHotSearch: function () {
      $('#chinaso_xwrs ul').hide();
      $('#chinaso_xwrs ul').eq(this.index).show();
      $('#chinaso_xwrs ul').eq(this.index + 1).show();
    },
    init: function () {
      var T = this;
      T.index = 0;
      T.len = 6;
      //请求数据
      $.ajax({
        type: 'GET',
        url: '/v5/general/v1/search/hotnews',
        dataType: 'json',
        contentType: 'application/x-www-form-urlencoded;charset=UTF-8',
        timeout: 30000,
        success: function (data) {
          if (data.data && data.data.length >= 30) {
            $('#chinaso_xwrs').html(T.buildHotSearch(data.data));
            T.showHotSearch();
            $('.chinaso_xwrs_change i').on('click', function () {
              T.change();
            });
          }
        },
        error: function (xhr, type) {

        }
      });
      $('#chinaso_xwrs').on('click', 'a', function () {
        try {
          window.sensors.track('hotsearchrecommend', {
            hotsearchrecommend_title: decodeURIComponent($(this).data('query'))
          });
        } catch (error) {
          console.log('getHotWords error->', error);
        }
        var href = '//www.chinaso.com/newssearch/all/allResults?q=' + $(this).data('query');
        console.log(href);
        window.location.href = href;
        // window.location.href = '//www.chinaso.com/newssearch/all/allResults?q=' + $(this).data("query");
      });
    }
  };
  return hotSearch;
}));



//////////////////
// WEBPACK FOOTER
// ./static/v4/js/hotSearch.js
// module id = a84ebfec72bdfc79e740
// module chunks = 1